// 设计器特殊的主题颜色

import navDesigner from 'Assets/images/nav_designer.png';
export const designerColor = '#013d74';

export const designerVars = {
    '--workbench-nav-bg-color': `url(${navDesigner}), linear-gradient(270deg, #002265 0%, #070E36 100%)`
};